/** @format */

export enum ProductReviewDrawerType {
	NONE = 'None',
	QUESTIONS = 'Questions',
	REVIEWS = 'Reviews'
}
